import { r as c, c as n, i as h, h as o, H as d, g as u, o as g } from "./main-bb89b2f2.js";
import { g as r } from "./getHTMLElements-42e066e3-4491c4a7.js";
import "vue";
const p = '*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.relative{position:relative}.top-\\[0\\]{top:0}.block{display:block}.flex{display:flex}.hidden{display:none}.h-0{height:var(--spacing-0)}.w-full{width:100%}.flex-row{flex-direction:row}.bg-gray-100{background-color:var(--color-neutral-steel-100)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}:host{display:block}.container:after,.container:before{content:"";display:none;height:var(--spacing-0);top:0}.container:after{left:50%}.container.is-open:after,.container.is-open:before{height:100%}.wrapper{background-color:var(--color-neutral-steel-100);display:block;height:var(--spacing-0);position:relative;width:100%}.is-open .wrapper{height:auto}.content{box-sizing:content-box;display:flex;flex-direction:row}.close-menu{display:none}.menu{position:relative;width:100%}.teaser{display:none}::slotted(.navigation-flyout-group){display:none}::slotted(.navigation-flyout-group.active){display:block}::slotted([slot=teaser]){display:none}::slotted([slot=teaser].active){display:block}@media (min-width:992px){.container:after,.container:before{background-color:var(--color-neutral-steel-100);display:block;position:absolute;right:50%;width:50vw;z-index:0}.container:after{right:auto}.wrapper{overflow:hidden;z-index:1}.content{padding-bottom:50px;padding-top:50px}.animation-container{height:var(--spacing-0);transition:height .2s ease-in}.close-menu{cursor:pointer;display:block;right:0;top:9px;z-index:10}.close-menu,.lg\\:absolute{position:absolute}.lg\\:right-1\\/2{right:50%}.lg\\:right-auto{right:auto}.lg\\:top-\\[9px\\]{top:9px}.lg\\:right-\\[0\\]{right:0}.lg\\:z-\\[1\\]{z-index:1}.lg\\:block{display:block}.lg\\:w-\\[50vw\\]{width:50vw}.lg\\:cursor-pointer{cursor:pointer}.lg\\:overflow-hidden{overflow:hidden}.lg\\:bg-gray-100{background-color:var(--color-neutral-steel-100)}.lg\\:pt-\\[50px\\]{padding-top:50px}.lg\\:pb-\\[50px\\]{padding-bottom:50px}}@media (min-width:1280px){.menu{width:66.666667%}.teaser{width:33.333333%}.teaser,.xl\\:block{display:block}.xl\\:w-2\\/3{width:66.666667%}}.static{position:static}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}@media (min-width:992px){.lg\\:overflow-visible{overflow:visible}}', v = p, m = class {
  constructor(t) {
    c(this, t), this.lhHeaderComponentRegister = n(this, "lhHeaderComponentRegister", 7), this.flyoutNavigationUpdated = n(this, "lhFlyoutNavigationUpdated", 7), this.flyoutNavigationClosed = n(this, "lhFlyoutNavigationClosed", 7), this.menuTimeout = null, this.activeNavItem = null, this.upcomingNavItem = null, this.currentLevel = 2, this.closePanel = () => {
      this.heights = { 2: 0, 3: 0 }, this.contentHeight = "0", this.containerHeight = "0", this.isOpen = !1, this.activeNavItem && (this.activeNavItem.isOpen = !1), this.activeNavItem = null, this.upcomingNavItem = null, this.flyoutNavigationClosed.emit();
    }, this.hoverTimeout = 500, this.heights = {}, this.isMobile = !1, this.isOpen = !1, this.isAnimating = !1, this.activeSubmenu = "", this.contentHeight = "0", this.containerHeight = "0";
  }
  openWatcher() {
    this.isAnimating = !0, setTimeout(() => this.isAnimating = !1, 200);
  }
  /**
   * this event is emitted in child component on any breakpoint
   * on hovering or clicking menu items to increase the menu level
   * @param evt
   */
  switchFlyoutNavItems(t) {
    if (t.stopImmediatePropagation(), clearTimeout(this.menuTimeout), t.detail.hasSubitems)
      if (this.activeNavItem === null)
        this.activeNavItem = t.target, this.activeNavItem.isOpen = !0;
      else {
        let e = this.hoverTimeout;
        t.detail.isMobile && (e = 0), this.upcomingNavItem = t.target, this.menuTimeout = setTimeout(() => {
          this.activeNavItem.isOpen = !1, this.activeNavItem = this.upcomingNavItem, this.activeNavItem.isOpen = !0, this.upcomingNavItem = null;
        }, e);
      }
    else
      this.activeNavItem && (this.activeNavItem.isOpen = !1), this.activeNavItem = null;
  }
  stopHoverIntent() {
    clearTimeout(this.menuTimeout);
  }
  /**
   * this event is emitted in child component only on desktop breakpoints
   * in didUpdate lifecycle hook
   * @param evt
   */
  setFlyoutNavigationHeight(t) {
    t.stopImmediatePropagation(), this.isMobile || (this.heights[3] = t.detail, this.updateFlyoutHeight());
  }
  setMobileFlyoutNavigationHeight(t) {
    t.stopImmediatePropagation(), this.isMobile && (t.detail > 0 && (this.heights[3] = t.detail), this.flyoutNavigationUpdated.emit({ height: this.heights[this.currentLevel], currentLevel: this.currentLevel }));
  }
  setMobileFlyoutNavigationLevel(t) {
    this.isMobile && (t.detail < 0 ? this.currentLevel = 2 : this.currentLevel = 3);
  }
  async closePreviousSubmenu() {
    this.activeNavItem && (this.activeNavItem.isOpen = !1);
  }
  async open(t) {
    this.isOpen = !0, this.performSwitchSubmenu(t);
  }
  async close() {
    this.closePanel();
  }
  async setFocus() {
    const { visibleFlyoutItems: t } = this.getChildren();
    if (t.length > 0) {
      const [e] = t;
      setTimeout(() => e.setFocus(), 100);
    }
  }
  async setTabIndex(t) {
    const { allFlyoutItems: e } = this.getChildren();
    e.forEach((i) => i.setTabIndex(t));
  }
  getChildren() {
    const t = r(this.hostElement, "patternlib-navigation-flyout-item");
    let e = r(this.hostElement, `.navigation-flyout-group[id="${this.activeSubmenu}"] patternlib-navigation-flyout-item`);
    return this.currentLevel === 2 ? {
      allFlyoutItems: t,
      currentFlyoutItems: this.isOpen ? e : [],
      visibleFlyoutItems: e.filter((i) => !i.isBackButton)
    } : (e = e.map((i) => r(i, "patternlib-navigation-flyout-item")).flat(), {
      allFlyoutItems: t,
      currentFlyoutItems: e,
      visibleFlyoutItems: e.filter((i) => !i.isBackButton)
    });
  }
  componentWillLoad() {
    this.heights = { 2: 0, 3: 0 }, this.isMobile = this.checkScreenSize(), this.lhHeaderComponentRegister.emit("navigation-flyout"), this.hostElement.addEventListener("keydown", (t) => {
      t.key === "Escape" && this.closePanel();
    });
  }
  componentDidUpdate() {
    if (this.isOpen) {
      const t = this.hostElement.querySelector(`.navigation-flyout-group[id="${this.activeSubmenu}"]`);
      this.heights[2] = t.offsetHeight, this.isMobile ? this.flyoutNavigationUpdated.emit({ height: this.heights[2], currentLevel: 2 }) : this.updateFlyoutHeight();
    }
  }
  connectedCallback() {
    const t = document.documentElement, e = "breakpoint", i = {
      attributes: !0
    }, a = (s) => {
      g(e, s) !== null && (this.isMobile = this.checkScreenSize());
    };
    typeof window.MutationObserver == "function" && (this.observer = new MutationObserver(a), this.observer.observe(t, i));
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  checkScreenSize() {
    return h(0, 992);
  }
  hasTeaser() {
    return this.hostElement.querySelectorAll('[slot="teaser"]').length > 0;
  }
  performSwitchSubmenu(t) {
    if (this.heights[3] = 0, this.activeSubmenu.trim().length > 0) {
      this.hostElement.querySelector(`.navigation-flyout-group[id="${this.activeSubmenu}"]`).classList.remove("active");
      const s = this.hostElement.querySelector(`[slot="teaser"][subnav-id="${this.activeSubmenu}"]`);
      s && s.classList.remove("active");
    }
    this.activeSubmenu = t, this.hostElement.querySelector(`.navigation-flyout-group[id="${this.activeSubmenu}"]`).classList.add("active");
    const i = this.hostElement.querySelector(`[slot="teaser"][subnav-id="${this.activeSubmenu}"]`);
    i && i.classList.add("active");
  }
  updateFlyoutHeight() {
    this.contentHeight = `${Math.max(this.heights[2], this.heights[3])}px`, this.containerHeight = this.contentHeight === "0px" ? "0px" : `${this.animationContainer.scrollHeight}px`;
  }
  render() {
    const t = {
      container: !0,
      "is-open": this.isOpen
    }, e = {
      wrapper: !0,
      "lg:overflow-hidden": !0,
      "lg:overflow-visible": this.isOpen && !this.isAnimating
    }, i = {
      height: this.contentHeight
    }, a = {
      height: this.containerHeight
    }, s = o("div", { key: "4a9821ce5d0e45cd9a58b28bbadcda61907970c6", class: "teaser" }, o("slot", { key: "e18b81a225734eb061377d549e855183bb71c19d", name: "teaser" }));
    return o(d, { key: "3602909bfa71cae9864056b72b482da564775f34" }, o("div", { key: "e8a280931256fb8150895a6dca6145534880fec1", class: t }, o("div", { key: "8d2789141583fb944fc8cdbb5e07973f465aab68", class: e }, o("div", { key: "92bf30e1d12853862345d2fcac70566a3fec0795", class: "animation-container", style: a }, o("button", { key: "e8d62428ea3c4e14e0fb9deb8632b449368a09a1", class: "close-menu", onClick: this.closePanel }, o("patternlib-icon", { key: "5f55940db4206f05190dd796067b12cb0e1525b8", iconName: "x", size: "32px" })), o("div", { key: "82554bf7c39c991bc7206b76a72e2cca57366c92", class: "content", style: i, ref: (l) => {
      this.animationContainer = l;
    } }, o("div", { key: "e63347dbda9b3923a1d785d25f9223d653be2d34", class: "menu" }, o("slot", { key: "74a8f025818b8e3952f0288c86f1483c66298ddd" })), this.hasTeaser() && s)))));
  }
  get hostElement() {
    return u(this);
  }
  static get watchers() {
    return {
      isOpen: ["openWatcher"]
    };
  }
};
m.style = v;
export {
  m as patternlib_navigation_flyout
};
